import React, { useEffect, useState } from "react";
import { MenuItem } from "@material-ui/core";
import { fetchConToken } from "../../helpers/fetch";
// import { useSelector } from "react-redux";
import { SelectValidator } from "react-material-ui-form-validator";

export const CboMotivosDeBaja = (props) => {
  const [listaMotivosBaja, setListaMotivosBaja] = useState([]);
  // const { areas } = useSelector(state => state.auth);

  useEffect(() => {
    const traerDatos = async () => {
      const response = await fetchConToken(`MotivosDeBaja`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (lista && lista?.length > 0) {
          let motivosFromApi = lista.map((mot) => {
            return {
              value: mot.id,
              display: mot.descripcion,
            };
          });
          setListaMotivosBaja(motivosFromApi);
        }
      }
    };
    traerDatos();
  }, []);

  return (
    <SelectValidator
      value={listaMotivosBaja?.length > 0 ? props.valor || '' : ''}
      onChange={props.manejadorInputChange}
      label="Motivo Baja"
      name="id_motivo_baja"
      disabled={(props.idPanel === 'idTabConsulta'  || props.disabled) ? true : false}
      margin="normal"
      fullWidth={true}
      validators={props.validators}
      errorMessages={props.errorMessages}
    >
      <MenuItem value="">
        <em>Seleccione</em>
      </MenuItem>
      {listaMotivosBaja.map((motivo) => (
        <MenuItem key={motivo.value} value={motivo.value}>
          {motivo.display}
        </MenuItem>
      ))}
    </SelectValidator>
  );
};
